<template>
  <div class="Score" v-if="options" :class="{ 'Score_show': isShow }">
    <transition name="fade">
      <div class="Score_cache" v-if="!isShow"></div>
    </transition>
    <div class="Score_wrapper">
      <div class="Score_qualiscore">
        <VueApexCharts class="Score_chart" type="radialBar" :options="options" :series="score"></VueApexCharts>
        <div class="Score_rate">
          <div class="Score_rate_percent">
            <animated-number
              :value="value"
              :easing="'easeOutQuad'"
              :duration="1200"
              :delay="600"
              :formatValue="format"
            />
          </div>
          <div class="Score_rate_qualiscore">Mon Qualiscore</div>
        </div>
        <div class="Score_label Score_label_left">0</div>
        <div class="Score_label Score_label_right">10</div>

        <transition name="scale">
          <button class="Score_cta" v-if="isShow" @click="openTooltip">?</button>
        </transition>
      </div>

      <div class="Score_share" ref="shareblock">
        <p class="Score_mention" v-if="higher >= 0"><b>{{ higher }}%</b> des répondants* ont obtenu un Qualiscore plus élevé que le vôtre.</p>
        <div class="Score_options">
          <a class="Score_share_cta" @click="openShare" v-scroll-to="'.Score_qualiscore'">Je partage mon Qualiscore</a>
          <a class="Score_reset_cta" @click="resetUser">Je recommence mon évaluation</a>
        </div>

        <transition name="fade">
          <div class="Score_share_wrapper" v-show="shareVisible">

            <social-sharing
              ref="buttons"
              :url="link"
              :title="scoreString"
              type="direct"
              hashtags=""
              :networks="overriddenNetworks"
              :description="scoreString"
              :quote="scoreString"
              inline-template>

              <div class="Score_share_socials">
                <network network="facebook">
                  <i class="fab fa-facebook-square"></i> Facebook
                </network>

                <network network="custom">
                  <i class="fab fa-facebook-messenger"></i> Messenger
                </network>

                <network network="twitter">
                  <i class="fab fa-twitter"></i> Twitter
                </network>

                <network network="whatsapp">
                  <i class="fab fa-whatsapp"></i> Whatsapp
                </network>
              </div>
            </social-sharing>

            <div class="Score_share_link">
              <p>Je partage le détail de mes réponses et mes conseils personnalisés</p>

              <input type="text" value="Lien copié !" ref="copy" readonly v-if="copyDelay" key="ok">
              <input type="text" :value="link" ref="copy" @click="copyClipboard" readonly v-else key="value">

              <a @click="copyClipboard">Copier</a>
            </div>

          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import AnimatedNumber from "animated-number-vue";
  import VueCookies from 'vue-cookies'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: "Score",
    components: {
      VueApexCharts,
      AnimatedNumber
    },
    props: [ 'value', 'higher', 'link' ],
    data() {
      return {
        shareVisible: false,
        isShow: false,
        options: null,
        score: [ 0 ],
        copyDelay: false,
        scoreString: "J'ai attribué la note de " + this.format(this.value) + "/10 à la qualité de mon logement, et vous ?",
        overriddenNetworks: {
          custom: {
            sharer: "https://www.facebook.com/dialog/send?link=" + this.link + "&app_id=521270401588372&redirect_uri=" + this.link + "",
            type: "popup"
          }
        }
      }
    },
    computed: {
      ...mapState([
        'user'
      ])
    },
    methods: {
      ...mapActions([
        'resetUserResponses'
      ]),
      openTooltip()
      {
        this.$emit('openPanel', { type: 'qualiscore' })
        this.$gtm.trackEvent({ category: 'button_resultats_tooltip', action: 'click', label: 'resultats_tooltip' })
      },
      format(value)
      {
        return Number(value).toFixed(1).replace(".", ",");
      },
      openShare()
      {
        this.$gtm.trackEvent({ category: 'button_resultats_link', action: 'click', label: 'resultats_partage_qualiscore' })

        window.removeEventListener('scroll', this.closeShare)

        this.shareVisible = !this.shareVisible

        // if(!document.body.classList.contains('.safari'))
        // TweenMax.to(window, 1, { scrollTo: '#Averages', ease: Power3.easeOut, onComplete: () => {
        //   document.body.addEventListener('scroll', this.closeShare)
        // } })

        setTimeout( () => {
          window.addEventListener('scroll', this.closeShare)
          document.body.querySelector('#Score').addEventListener('click', this.closeShare)
        }, 1100)
      },
      resetUser()
      {
        this.$gtm.trackEvent({ category: 'button_resultats_link', action: 'click', label: 'resultats_refaire_qualiscore' })
        VueCookies.remove('user_session')
        this.resetUserResponses()
        this.$router.push({ name: 'qualiscore' })
      },
      closeShare(e)
      {
        let els = e.type == 'click' ? e.path : null

        if(els){
          for (let i = 0; i < els.length; i++) {
            const element = els[i];
            if(element.classList && element.classList.contains('Score_share_wrapper'))
            {
              break
              return
            }else{
              if(i == els.length - 1)
              {
                this.shareVisible = false
                document.body.querySelector('#Score').removeEventListener('click', this.closeShare)
                window.removeEventListener('scroll', this.closeShare)
              }
            }
          }
        }else
        {
          this.shareVisible = false
          document.body.querySelector('#Score').removeEventListener('click', this.closeShare)
          window.removeEventListener('scroll', this.closeShare)
        }
      },
      copyClipboard()
      {
        if(this.copyDelay) return

        this.$gtm.trackEvent({ category: 'button_resultats_share', action: 'click', label: 'resultats_partage_qualiscore_copierlelien' })

        this.$refs.copy.select()
        document.execCommand("copy");
        this.copyDelay = true
        setTimeout( () => {
          this.copyDelay = false
        }, 2000 )
      }
    },
    created()
    {
      this.options = {
        colors: ["#B60F42"],
        chart: {
          fontFamily: 'Campton',
          animations: {
            enabled: true,
            easing: 'easeout',
            speed: 2800,
            animateGradually: {
              enabled: false
            },
            dynamicAnimation: {
              enabled: true,
              speed: 2800
            }
          }
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: "75%"
            },
            startAngle: -90,
            endAngle: 90,
            track: {
              background: '#F3F4F7',
              startAngle: -90,
              endAngle: 90,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false
              }
            }
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            type: this.value < 3 ? 'vertical' : 'horizontal',
            inverseColors: this.value < 3 ? true : false,
            gradientToColors: ["#1F276D"],
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: "round"
        },
        labels: ["Progress"]
      }

      this.$tools.disableScroll()
    },
    mounted()
    {
      setTimeout( () => {
        this.score = [ this.value * 10 ]
      }, 700)

      setTimeout( () => {
        this.isShow = true
      }, 1000)

      setTimeout( () => {
        this.$tools.enableScroll()
      }, 1800)
    }
  }
</script>

<style lang="stylus">
.Score

  display table
  width 100%
  max-width 500px

  &_show

    .Score_share

      opacity 1
      pointer-events auto

  &_cache

    position fixed
    z-index 1000
    top 0px
    left 0px
    width 100vw
    height 100vh
    background-color white
    transition-delay 1s
    transition-duration 2s

  &_wrapper

    position relative
    z-index 10001

  &_mention

    font-size: 16px;
    color: $s1;
    text-align: center;
    line-height: 24px;
    cursor pointer
    display block
    max-width 320px
    margin 45px auto 20px auto

    b

      color white
      background-color $blue
      padding 1px 4px
      margin-right 2px
      border-radius 3px

  &_options

    display flex
    flex-direction row
    align-items center
    justify-content center
    margin 0px auto 20px auto

    a

      font-size: 16px;
      color: $s1;
      text-align: center;
      line-height: 24px;
      text-decoration underline
      cursor pointer
      display inline-block
      margin 0px 13px

  &_share

    margin auto
    transition opacity 0.6s 1s $ease
    opacity 0
    pointer-events none
    position relative

    &_wrapper

      background: #FFFFFF;
      position absolute
      top calc(100% + 20px)
      left 50%
      transform translateY(0px) translateX(-50%)
      box-shadow: 0 2px 24px 0 rgba(0,0,0,0.10);
      border-radius: 5px
      width calc(100% - 60px)
      max-width 315px
      box-sizing border-box
      padding 25px 20px

      &:before

        content ''
        position absolute
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid white;
        left 50%
        transform translateX(-50%)
        top -10px

    &_link

      margin-top 20px

      input

        cursor copy
        appearance none
        background-color white
        border: 1px solid $n2
        border-radius: 5px;
        color $blue
        font-size: 12px;
        letter-spacing: 0;
        text-align: center;
        height 35px
        width 100%
        display block
        margin 15px auto

      p

        font-size: 12px;
        color $s1
        letter-spacing: 0;
        text-align: center;
        line-height: 18px;

      a

        font-family: $f-title
        font-size: 12px;
        color: $red
        display block
        margin 0px auto
        cursor copy
        text-align: center;

    &_socials

      display flex
      flex-direction row
      flex-wrap wrap
      align-items center
      justify-content space-between
      border-bottom 1px solid $n2

      span

        width 50%
        font-family: $f-title
        font-size: 12px;
        color: $blue
        margin-bottom 20px
        cursor alias

        i

          font-size 20px
          vertical-align middle
          margin-right 15px

  &_cta

    position absolute
    display block
    padding 0px
    display flex
    flex-direction column
    align-items center
    justify-content center
    transition-delay 0s
    font-family: $f-title
    font-weight 500
    font-size: 14px;
    color: white
    letter-spacing: -0.3px;
    text-align: center;
    line-height: 30px;
    height 30px
    width 30px
    background-color $blue
    border-radius 50%
    padding-left 1px
    right 10%
    top 18%
    border 0px
    cursor pointer
    appearance none
    transition transform 0.4s $ease

    &:hover

      transform scale(1.15)

  &_chart

    width 100%
    pointer-events none

  &_rate

    position absolute
    bottom -15px
    left 50%
    transform translateX(-50%)
    text-align center

    &_percent

      font-size 70px
      letter-spacing -1.05px
      font-family $f-title
      font-weight 500
      line-height 70px
      color $blue

    &_qualiscore

      font-size: 14px;
      color: $blue
      line-height: 25px;
      background-color $n3
      width 120px
      height 25px
      margin auto
      border-radius 10px

  &_label

    font-family: $f-title
    font-weight 500
    font-size: 14px;
    color: $blue
    letter-spacing: -0.3px;
    text-align: center;
    line-height: 14px;
    position absolute
    bottom -15px

    &_left

      left 14.5%

      @media $small

        left 15.5%

    &_right

      right 13.5%

      @media $small

        right 13.5%
</style>
